export const HOST = [
    'https://test-customer.ihuhoo.com/support',
    'https://customer.tradeup.com/support',
    'https://ams-customer-us-qa22.tigerbrokers.net/support'
];

export const API = {
    transfer: {
        brokers: '/api/v1/broker/config/list',
        brokerInfo: '/api/v1/broker/config/:id'
    },
    /**
     * https://apidocs.tigerfintech.com/repository/23?branch=master&type=api&uri=APP-Web.json#/operations/get--api-v1-individual-{doc_scope}-{link_code}
     * RD @dingyaguang
     */
    agreement: '/api/v1/individual/statements/:code'
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.customerSupport?.TBUS;

    cfg && HOST.fill(cfg);
}
